<agr-form-dialog
  [formGroup]="formGroup"
  (confirm)="save()"
  (alt)="alt()"
  (cancel)="cancel()"
  [data]="data"
>
  <div class="spacing--margin-horizontal spacing--margin-top">
    <div class="spacing--margin-bottom">
      <div class="spacing--margin-top flex--row flex--wrap">
        <div class="flex--column">
          <span class="text--small text--bold label">
            {{ 'fecal-scoring.detail.for' | translate }}
          </span>
          <span class="text--small label">
            {{ getDate() | agrDate: 'dd-MM-yyyy' }}
          </span>
        </div>
      </div>
    </div>

    <div class="spacing--margin-top">
      <div class="spacing--margin-bottom">
        <div class="spacing--margin-top flex--row flex--wrap">
          <div class="flex--column">
            <span class="text--small text--gray label">
              {{ 'fecal-scoring.detail.customer.name' | translate }}
            </span>
            <span class="text--small text--bold label">
              {{ data.customer?.name }}
            </span>
          </div>
          <div class="flex--column spacing--margin-left">
            <span class="text--small text--gray label">
              {{ 'fecal-scoring.detail.location.name' | translate }}
            </span>
            <span class="text--small text--bold label">
              {{ location?.name }}
            </span>
          </div>
          <div class="flex--column spacing--margin-left">
            <span class="text--small text--gray label">
              {{ 'fecal-scoring.detail.location.address' | translate }}
            </span>
            <span class="text--small text--bold label">
              {{ location?.street }} {{ location?.houseNumber }} {{ location?.houseNumberAddition }}
            </span>
          </div>
          <div class="flex--column spacing--margin-left">
            <span class="text--small text--gray label">
              {{ 'fecal-scoring.detail.location.postalcode' | translate }}
            </span>
            <span class="text--small text--bold label">
              {{ location?.postalCode }}
            </span>
          </div>
          <div class="flex--column spacing--margin-left">
            <span class="text--small text--gray label">
              {{ 'fecal-scoring.detail.location.city' | translate }}
            </span>
            <span class="text--small text--bold label">
              {{ location?.city }}
            </span>
          </div>
        </div>
      </div>
    </div>

    <div class="flex--column">
      <mat-form-field class="flex__child--auto spacing--margin-top">
        <mat-label>{{ 'fecal-scoring.detail.label.name' | translate }}</mat-label>
        <input
          matInput
          #fecalScoringNameInput
          (keypress)="keyPress($event)"
          formControlName="fecalScoringName"
          placeholder="{{ 'fecal-scoring.detail.label.name' | translate }}"
          data-test="fecal-scoring-detail__name"
        />
        <mat-error *ngIf="formGroup.controls.fecalScoringName.invalid">
          {{ 'fecal-scoring.detail.error-name' | translate }}</mat-error
        >
      </mat-form-field>
    </div>

    <div class="flex--column" *ngIf="isMobile$ | async">
      <mat-form-field class="flex__child--auto spacing--margin-top">
        <mat-select
          [hideSingleSelectionIndicator]="true"
          placeholder="{{ 'fecal-scoring.detail.pen-select' | translate }}"
          [(value)]="selectedTabIndex"
          data-test="fecal-scoring-detail__pen-select"
        >
          <mat-option *ngFor="let tab of this.tabs; let i = index" [value]="i"
            >{{ 'fecal-scoring.detail.pen' | translate }} {{ i + 1 }}</mat-option
          >
        </mat-select>
      </mat-form-field>
    </div>

    <div class="">
      <mat-tab-group
        animationDuration="0"
        [(selectedIndex)]="selectedTabIndex"
        color="accent"
        [mat-stretch-tabs]="false"
        [ngClass]="penTabsClass"
      >
        <mat-tab *ngFor="let tab of this.tabs; let i = index" class="">
          <ng-template mat-tab-label
            >{{ 'fecal-scoring.detail.pen' | translate }} {{ i + 1 }}</ng-template
          >
          <app-fecal-scoring-detail-pen-form
            [penFormGroup]="penFormGroups[i]"
            [index]="i"
            (deletePen)="delete($event)"
            [canDelete]="canDeletePen"
            [isMobile]="isMobile$ | async"
          >
          </app-fecal-scoring-detail-pen-form>
        </mat-tab>
      </mat-tab-group>
    </div>
  </div>
</agr-form-dialog>
